module.exports = __webpack_public_path__ + "static/media-e39e831b5c1d01db99faa649213d7bf0.jpg";